export default __webpack_public_path__ + "static/media/radar_urgent.a4ff4b1f.svg";